"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// from https://github.com/airbnb/react-dates/blob/master/src/defaultPhrases.js
const calendarLabel = 'Calendrier';
const roleDescription = 'Sélecteur de date';
const closeDatePicker = 'Fermer ';
const clearDate = 'Supprimer la date';
const jumpToPrevMonth = 'Reculer pour passer au mois précédent.';
const jumpToNextMonth = 'Avancer pour passer au mois suivant.';
const keyboardShortcuts = 'Raccourcis clavier ';
const showKeyboardShortcutsPanel = 'Ouvrir le panneau de raccourcis clavier.';
const hideKeyboardShortcutsPanel = 'Fermez le panneau de raccourcis.';
const openThisPanel = 'Ouvrir le panneau. ';
const enterKey = 'Touche Entrée ';
const leftArrowRightArrow = 'Touches de direction droite et gauche';
const upArrowDownArrow = 'Touches de direction haut et bas';
const pageUpPageDown = 'Touches Page précédente et Page suivante';
const homeEnd = 'Touches Accueil et Fin';
const escape = 'Touche Échap.';
const questionMark = `Point d'interrogation`;
const selectFocusedDate = 'Sélectionner la date mise au point.';
const moveFocusByOneDay = `Reculer (à gauche) et avancer (à droite) d'un jour.`;
const moveFocusByOneWeek = `Reculer (vers le haut) et avancer (vers le bas) d'une semaine.`;
const moveFocusByOneMonth = 'Changer de mois.';
const moveFocustoStartAndEndOfWeek = 'Aller au premier ou au dernier jour de la semaine.';
const returnFocusToInput = 'Revenir au champ de saisie de la date.';
const keyboardForwardNavigationInstructions = `Naviguer vers l'avant pour interagir avec le calendrier et sélectionner une date. Appuyer sur la touche Point d'interrogation pour obtenir les raccourcis clavier permettant de modifier les dates.`;
const keyboardBackwardNavigationInstructions = `Naviguer en arrière pour interagir avec le calendrier et sélectionner une date. Appuyer sur la touche Point d'interrogation pour obtenir les raccourcis clavier permettant de modifier les dates.`;
const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Julliet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
const weekDays = {
  Su: 'Dim',
  Mo: 'Lun',
  Tu: 'Mar',
  We: 'Mer',
  Th: 'Jeu',
  Fr: 'Ven',
  Sa: 'Sam'
};
const chooseAvailableStartDate = _ref => {
  let {
    date
  } = _ref;
  return `Choisir ${date}. Disponible.`;
};
const chooseAvailableEndDate = _ref2 => {
  let {
    date
  } = _ref2;
  return `Non disponible. ${date}`;
};
const chooseAvailableDate = _ref3 => {
  let {
    date
  } = _ref3;
  return date;
};
const dateIsUnavailable = _ref4 => {
  let {
    date
  } = _ref4;
  return `Not available. ${date}`;
};
const dateIsSelected = _ref5 => {
  let {
    date
  } = _ref5;
  return `Choisie. ${date}`;
};
const dateIsSelectedAsStartDate = _ref6 => {
  let {
    date
  } = _ref6;
  return `Choisie comme date de début. ${date}`;
};
const dateIsSelectedAsEndDate = _ref7 => {
  let {
    date
  } = _ref7;
  return `Choisie comme date de fin. ${date}`;
};
const dictionary = {
  en: undefined,
  // uses react-dates defaults
  fr: {
    calendarLabel,
    roleDescription,
    jumpToPrevMonth,
    jumpToNextMonth,
    keyboardShortcuts,
    showKeyboardShortcutsPanel,
    hideKeyboardShortcutsPanel,
    openThisPanel,
    enterKey,
    leftArrowRightArrow,
    upArrowDownArrow,
    pageUpPageDown,
    homeEnd,
    escape,
    questionMark,
    selectFocusedDate,
    moveFocusByOneDay,
    moveFocusByOneWeek,
    moveFocusByOneMonth,
    moveFocustoStartAndEndOfWeek,
    returnFocusToInput,
    months,
    weekDays,
    chooseAvailableStartDate,
    chooseAvailableEndDate,
    chooseAvailableDate,
    dateIsUnavailable,
    dateIsSelected,
    dateIsSelectedAsStartDate,
    dateIsSelectedAsEndDate,
    closeDatePicker,
    clearDate,
    keyboardForwardNavigationInstructions,
    keyboardBackwardNavigationInstructions
  }
};
var _default = exports.default = dictionary;